// extracted by mini-css-extract-plugin
module.exports = {"search":"styles_search__O7f7V","results":"styles_results__1x6tl","noResults":"styles_noResults__2kXf1"};